import { memo } from "react"

interface ResendArrowIconProps {
  isDisabled: boolean
}

const ResendArrowIcon = (props: ResendArrowIconProps) => {
  const { isDisabled } = props

  return (
    <>
      {isDisabled && (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.7301 16.8103C19.6921 16.721 19.6378 16.6396 19.5701 16.5703L16.6401 13.6403C16.4531 13.4396 16.1715 13.357 15.9058 13.4249C15.64 13.4928 15.4325 13.7003 15.3647 13.966C15.2968 14.2317 15.3794 14.5133 15.5801 14.7003L17.2301 16.3503H10.1401C8.0966 16.3503 6.44005 14.6937 6.44005 12.6503V10.5003C6.42255 8.50043 8.00137 6.85065 10.0001 6.78027H17.9001C18.3143 6.78027 18.6501 6.44449 18.6501 6.03027C18.6501 5.61606 18.3143 5.28027 17.9001 5.28027H10.0001C7.20197 5.37753 4.98755 7.68053 5.00005 10.4803V12.6503C5.00556 15.5199 7.33045 17.8448 10.2001 17.8503H17.2901L15.5801 19.5003C15.2876 19.7931 15.2876 20.2675 15.5801 20.5603C15.7199 20.7019 15.911 20.7812 16.1101 20.7803C16.3093 20.7824 16.5008 20.7029 16.6401 20.5603L19.5701 17.6303C19.6378 17.5609 19.6921 17.4795 19.7301 17.3903C19.8102 17.2052 19.8102 16.9953 19.7301 16.8103Z"
            fill="#D1D1D1"
          />
        </svg>
      )}

      {!isDisabled && (
        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.7301 16.8103C19.6921 16.721 19.6378 16.6396 19.5701 16.5703L16.6401 13.6403C16.4531 13.4396 16.1715 13.357 15.9058 13.4249C15.64 13.4928 15.4325 13.7003 15.3647 13.966C15.2968 14.2317 15.3794 14.5133 15.5801 14.7003L17.2301 16.3503H10.1401C8.0966 16.3503 6.44005 14.6937 6.44005 12.6503V10.5003C6.42255 8.50043 8.00137 6.85065 10.0001 6.78027H17.9001C18.3143 6.78027 18.6501 6.44449 18.6501 6.03027C18.6501 5.61606 18.3143 5.28027 17.9001 5.28027H10.0001C7.20197 5.37753 4.98755 7.68053 5.00005 10.4803V12.6503C5.00556 15.5199 7.33045 17.8448 10.2001 17.8503H17.2901L15.5801 19.5003C15.2876 19.7931 15.2876 20.2675 15.5801 20.5603C15.7199 20.7019 15.911 20.7812 16.1101 20.7803C16.3093 20.7824 16.5008 20.7029 16.6401 20.5603L19.5701 17.6303C19.6378 17.5609 19.6921 17.4795 19.7301 17.3903C19.8102 17.2052 19.8102 16.9953 19.7301 16.8103Z"
            fill="#333333"
          />
        </svg>
      )}
    </>
  )
}

export default memo(ResendArrowIcon)
